import { MediaFileData } from '../File/types'

const FileDataFabric = {
  create(data: MediaFileData): MediaFileData {
    const fileData: any = {
      guid: data.guid,
      file: data.file,
      type: data.type,
      abstractType: data.abstractType,
      preview: data.preview,
      blobFile: data.blobFile,
      name: data.name,
      status: data.status,
    }

    if (data.file) {
      // eslint-disable-next-line id-blacklist
      fileData.file = data.file
    }
    return fileData
  },
}

export default FileDataFabric
